import gql from 'graphql-tag';
import S3Object from './s3_object';

export default gql`
  fragment ContentEmailSpec on ContentEmailSpec {
    id
    title
    segment_ids
    all_users
    created_at
    content_specs {
      id
      content_type
    }
    send_at
    delivery_interval
    grouping_interval
    banner {
      ...S3Object
    }
    banner_url
    intro
    footer
    email_from
    email_reply_to
    subject
    config_status
    use_sto
  }
  ${S3Object}
`;
